export default {
    type: 'widget',
    config: {
        minWidth: {
            desktop: 200,
            mobile: 120
        },
        align: 'left'
    },
    default: {
        label: 'Game'
    },
    sort: 'name',
    unique: [
        {
            key: 'status',
            type: 'checklist',
            default: 'enabled',
            name: 'Change',
            options: [
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show status',
                    description: 'Show rating change (e.g. +2.0)'
                },
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide status',
                    description: 'Don\'t show rating change.'
                }
            ]
        },
        {
            key: 'date',
            type: 'checklist',
            default: 'enabled',
            name: 'Date',
            options: [
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show date',
                    description: 'Show date rating was made'
                },
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide date',
                    description: 'Don\'t show date rating was made'
                }
            ]
        },
        {
            key: 'tags',
            type: 'checklist',
            default: 'enabled',
            name: 'Tags',
            options: [
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show tags',
                    description: 'Show any applicable tags'
                },
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide tags',
                    description: 'Don\'t show any applicable tags'
                }
            ]
        },
        {
            key: 'comment',
            type: 'checklist',
            default: 'enabled',
            name: 'Comment',
            options: [
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show comment',
                    description: 'Show comment if exists'
                },
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide comment',
                    description: 'Don\'t show comment'
                }
            ]
        }
    ],
    lang: {
        name: 'Rating Info',
        views: ['list'],
        category: 'Game',
        description: 'Summary of rating with optional stuff.'
    }
}